import { PaginatedList } from './common';

// GET /api/v1/smart_trading/positions
export type SmartTardePositionsParams = {
  limit?: number;
  offset?: number;
  sort?: string;
};

export type SmartTardePositionsResponse = PaginatedList<SmartTradePosition>;
export type SmartTradePositionResponse = {
  data: SmartTradePosition;
};
export type SmartTradePositionUserActionsResponse = PaginatedList<UserAction>;

type EventType =
  | 'POSITION_CREATED'
  | 'POSITION_UPDATED'
  | 'POSITION_CANCELED'
  | 'POSITION_CLOSED';
type StatusType = 'PENDING' | 'IN_PROGRESS' | 'FINISHED' | 'CANCELED';

export type UserAction = {
  positionId: string;
  userId: string;
  eventType: EventType;
  isRejected: boolean | null;
  rejectedReason: string | null;
  status: StatusType;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type TradeSide = 'buy' | 'sell';
export type OrderType = 'market' | 'limit';

export type Order = {
  orderId: string;
  clientOrderId: string;
  createdAt: string;
  side: 'buy' | 'sell';
  type: 'limit' | 'market';
  status: string;
  amount: string;
  price: string;
  filled: string;
  remaining: string;
  averagePrice: string | null;
  feeCost: string | null;
  feeAsset: string | null;
  id: string;
};

export type EntryLevel = {
  weight: string;
  price: string;
  id: string;
  orders: Order[];
  status: string;
  displayPrice: string | null;
};
export type TakeProfitLevel = {
  weight: string;
  percentage: string | null;
  price: string;
  id: string;
  orders: Order[];
  status: string;
  displayPrice: string | null;
};

export type StopLossLevel = {
  weight: string;
  percentage: string | null;
  price: string;
  id: string;
  orders: Order[];
  status: string;
  displayPrice: string | null;
};

export type SmartTradePosition = {
  createdAt: string;
  updatedAt: string;
  name?: null | string;
  exchangeKeyId: number;
  side: TradeSide;
  entryCost: string;
  entryLevels: EntryLevel[];
  entryMaxNumActiveOrders: number;
  isTrailingTakeProfit: boolean;
  trailingTakeProfitDeviation: string | null;
  trailingTakeProfitThreshold: string | null;
  trailingTakeProfitPrice: string | null;
  trailingTakeProfitDisplayPrice: string | null;
  isTakeProfitFixed: boolean;
  takeProfitLevels: TakeProfitLevel[];
  isStopLossFixed: boolean | null;
  stopLossToBreakEven: boolean | null;
  stopLossLevels: StopLossLevel[];
  userId: number;
  priceAtCreated: string;
  exchangeMarketSymbolId: number;
  marketName: string;
  baseAsset: string;
  quoteAsset: string;
  exchangeName: string;
  orderType: OrderType;
  id: string;
  status: string;
  trailingTakeProfitOrders: unknown[];
  averagePrice: string | null;
  totalFilled: string;
  totalCost: string;
  realisedPnl: string | null;
  unrealisedPnl: string | null;
  realisedReturn: string | null;
  unrealisedReturn: string | null;
  futuresPositionMode: PositionMode;
  leverage?: number;
};

export enum PositionMode {
  OneWayMode = 'one_way_mode',
  HedgeMode = 'hedge_mode',
}

export enum Markets {
  Futures = 'futures',
  Spot = 'spot',
}

export type AddFundsParams = { cost: number; asset: string };
